import React, { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNotification } from "@hooks/useNotification";
import "date-fns";
import "@css/pages/hoursPlanner/hoursPlanner.css";
import ModalDelete from "@components/modals/modalDelete";
import { EmployerCertification } from "@services/all.services";
import { NotificationUtil } from "@utils/notification.utils";

const ModalDeleteCertification = ({
  isOpen,
  idCertification,
  onClickClose
}) => {
  const { showError, showInfo, showSuccess } = useNotification();

  const { t } = useTranslation("pages.employés.parcours&Certifications");
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteCertification = useCallback(() => {
    setIsDeleting(true);
    EmployerCertification.deleteById(idCertification)
      .then(async (response) => {
        const contentResponse = response.data.data;
        if (contentResponse?.success) {
          showSuccess("delete_action_success", {
            object: "certification"
          });
          const certificationData = contentResponse.data;
          const resNotif = NotificationUtil.emploieCertificationUpdate(
            certificationData
          );
          if (resNotif?.data?.deniedNotification) showInfo("ATTENTION");
          onClickClose();
        } else {
          showError("error");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setIsDeleting(false));
  }, [idCertification]);

  return (
    <ModalDelete
      isOpen={isOpen}
      toggle={onClickClose}
      content={t("Êtes-vous sûr de vouloir supprimer cette certification ?")}
      onCloseModal={onClickClose}
      handleDelete={deleteCertification}
      colorBtn="green"
      isLoading={isDeleting}
    />
  );
};

export default memo(ModalDeleteCertification);
